import { css } from 'linaria';
import { styled } from 'linaria/react';

export const container = css`
  display: flex;
  flex-flow: column wrap;
  align-items: baseline;

  @media (--only-mobile) {
    display: flex;
    flex-direction: column;
    align-items: baseline;
  }
`;

export const bestPriceMarker = css`
  gap: var(--space-50);
`;

export const oldNewPriceMarker = css`
  gap: 0;
`;

export const mainPriceDefaultClass = css`
  display: inline-block;
`;

export const newOldPriceStyle = css`
  span {
    color: var(--secondary-red-primary);
  }
`;

export const bestPriceStyle = css`
  color: var(--text-primary);
  background-color: var(--secondary-yellow_primary);
  padding-left: var(--space-50);
`;

export const padLeft = css`
  padding-left: var(--space-25);
`;

export const padRight = css`
  padding-right: var(--space-50);
`;

export const specialPriceContainer = css`
  display: inline-block;
  margin-right: var(--space-200);

  @media (--only-mobile) {
    width: 100%;
    margin-right: 0;
  }
`;

export const specialOldPriceWrap = css`
  display: flex;
  flex-direction: column;
  align-items: baseline;
`;

export const oldPriceCrossed = css`
  position: relative;
  display: inline-block;
  line-height: var(--space-250);

  &::after {
    position: absolute;
    top: 50%;
    left: -2px;
    display: block;
    width: 108%;
    height: 1.5px;
    background: var(--secondary-red-primary);
    content: '';
  }
`;

export const oldPriceWrap = css`
  color: var(--text-primary);

  @media (--only-mobile) {
    font-size: 12px !important;
  }
`;

export const oldCurrencyWrap = css`
  font-weight: 500;
  font-size: 12px !important;
  color: var(--text-primary);
`;

export const bestPriceContainer = css`
  display: flex;
  align-items: center;
  gap: var(--space-75);
`;

export const BestPriceIconContainer = styled.div`
  display: flex;
  align-items: center;
  width: 20px;
  height: 20px;
  padding: var(--space-50);
  background-color: var(--secondary-yellow_primary);

  svg {
    display: block;
  }
`;

export const oldPriceWrapper = css`
  display: flex;
  align-items: flex-start;
  gap: var(--space-100);
  margin-bottom: var(--space-50);
`;
